const config = {
    apiUrl: "https://apildc.cloudgentechnologies.com"

}
export default config;